// extracted by mini-css-extract-plugin
export var CaseStudiesInfo = "caseStudies-module--CaseStudiesInfo--1134f";
export var LinkBtn = "caseStudies-module--LinkBtn--bf1da";
export var TagBox = "caseStudies-module--TagBox--ced1f";
export var TagWrapper = "caseStudies-module--TagWrapper--ea6aa";
export var case_studies_wrap = "caseStudies-module--case_studies_wrap--0607e";
export var case_study_content = "caseStudies-module--case_study_content--f3ed4";
export var case_study_list = "caseStudies-module--case_study_list--b9639";
export var portfoliolist = "caseStudies-module--portfoliolist--91b2e";
export var slide_wrap = "caseStudies-module--slide_wrap--aa95f";